<template lang="pug">
b-modal#fundTransferProvider(
  ref="fundTransferProvider"
  :title="$t('ui.fund_transfer_provider')"
  centered
  no-fade
  no-close-on-backdrop
  no-enforce-focus
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  hide-footer
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      .disabled-input.form-control.form-control-sm
        span {{ account_id }}
        div.float-right(v-if="hasTransferredBalance")
          span.font-weight-bold(
            :title="$n(transferBalance, 'currency')"
            :class="$helpers.fontClassName(transferBalance)"
          ) {{ $n(transferBalance, 'currency') }}
    b-form-group
      .d-flex.justify-content-end.mb-2
        template(v-if="hasTransferredBalance")
          b-button.mr-1(
            size="sm"
            variant="primary"
            @click="traceOutstanding"
            :disabled="loading || tracingOutstanding || !hasTransferredBalance"
          )
            i.fa.fa-search.mr-1
            span {{ $t("ui.trace") }}
        b-button(
          size="sm"
          variant="warning"
          @click="confirmBulkWithdrawal"
          :disabled="loading || bulkEligibleProviders.length === 0"
        )
          i.fa.fa-arrow-circle-down.mr-1
          span {{ $t("ui.bulk_withdrawal") }}        
      .clusterize-scroll
        .table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="10%")
                  span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.balance')") {{ $t("ui.balance") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.outstanding_balance')") {{ $t("ui.outstanding_balance") }}
                th.text-center(width="10%")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody
              tr(v-if="loading")
                td(colspan="8").text-center.py-3
                  i.fa.fa-spinner.fa-spin.fa-lg
              tr(v-else-if="providerList.length == 0")
                td(colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in providerList")
                td
                  span(:title="item.actual_name") {{ item.actual_name }}
                td.text-right
                  i.fa.fa-spinner.fa-spin(v-if="item.loadingBalance")
                  span.text-danger.font-weight-bold(v-else-if="item.balanceError") ERROR
                  span.font-weight-bold(v-else-if="item.balance !== undefined && item.balance !== null" :title="$n(item.balance, 'currency')" :class="$helpers.fontClassName(item.balance)") {{ $n(item.balance, 'currency') }}
                  span(v-else).text-muted -
                td.text-right
                  i.fa.fa-spinner.fa-spin(v-if="tracingOutstanding || item.clearingOutstanding")
                  span.font-weight-bold(
                    v-else-if="item.outstanding !== undefined && item.outstanding !== null"
                    :title="$n(item.outstanding, 'currency')"
                    :class="[$helpers.fontClassName(item.outstanding), { clickable: canClearOutstanding(item) }]"
                    @click="canClearOutstanding(item) && clearOutstanding(item)"
                  ) {{ $n(item.outstanding, 'currency') }}
                  span(v-else).text-muted -
                td.text-center
                  //- i need action to do manual deposit and withdrawal
                  b-button.mr-1(size="sm" variant="primary" @click="manualDeposit(item)" :title="$t('ui.deposit')" :disabled="loading")
                    i.fa.fa-plus
                  b-button(size="sm" variant="danger" @click="manualWithdrawal(item)" :title="$t('ui.withdrawal')" :disabled="loading")
                    i.fa.fa-minus
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-arrow-circle-down" :text="$t('ui.bulk_withdrawal')" isModal=true)

  manualdeposit(ref="manualdeposit" :item="manualDepositItem" @clicked="afterManualDeposit" @failed="handleFailed")

  b-modal#withdrawalResult(
    ref="withdrawalResult"
    :title="$t('ui.withdrawal_result')"
    centered
    no-fade
    size="md"
    hide-footer
  )
    .table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th(width="25%")
              span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
            th.text-right(width="25%")
              span(:title="$t('ui.balance')") {{ $t("ui.balance") }}
            th.text-center(width="25%")
              span(:title="$t('ui.status')") {{ $t("ui.status") }}
        tbody
          tr(v-if="withdrawalResultList.length == 0")
            td(colspan="4").text-center
              span {{ $t('message.no_data_available') }}
          tr(v-for="(item, index) in withdrawalResultList" :key="index")
            td
              span(:title="item.provider") {{ item.provider }}
            td.text-right
              span.font-weight-bold(v-if="item.balance !== undefined && item.balance !== null" :title="$n(item.balance, 'currency')" :class="$helpers.fontClassName(item.balance)") {{ $n(item.balance, 'currency') }}
              span.text-danger.font-weight-bold(v-else) ERROR
            td.text-center
              i.fa.fa-spinner.fa-spin(v-if="item.status === 'processing'")
              b-badge(v-else-if="item.status === 'success'" variant="success").text-white {{ $t("ui.success") }}
              b-badge(v-else-if="item.status === 'failed'" variant="danger").text-white {{ $t("ui.failed") }}
              span.text-danger(v-else) ERROR
    div(slot="modal-footer")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeResultModal()" size="sm" variant="primary").mr-1
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import manualdeposit from "@/components/member/manualDeposit.vue";
import CryptoJS from "crypto-js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    manualdeposit
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      tracingOutstanding: false,
      feedback: {
        success: true,
        status: ""
      },
      account_id: "",
      providerList: [],
      manualDepositItem: {},
      withdrawalResultList: [],
      transferBalance: 0
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    bulkEligibleProviders() {
      return this.providerList.filter(
        provider => provider && provider.actual_code && provider.aggregator
      );
    },
    hasTransferredBalance() {
      const balance = Number(this.transferBalance);
      return Number.isFinite(balance) && balance !== 0;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getMemberWallet: function() {
      let url = config.memberWalletGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                const wallet = Array.isArray(response.data.dt) ? response.data.dt[0] : null;
                const transferredBalance = wallet ? parseFloat(wallet.transferred_balance) : NaN;
                this.transferBalance = Number.isFinite(transferredBalance) ? transferredBalance : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getProviderList: function() {
      let url = config.providerOperatorListTransferUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        // is_free: false,
        // credit_type: "TRANSFER",
        // balance: true,
        // user_id: this.item.second_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = response.data.dt;
                // Initialize loadingBalance for each provider and async call getBalanceFT
                this.providerList.forEach((provider, index) => {
                  this.$set(provider, 'loadingBalance', true);
                  this.$set(provider, 'balanceError', false);
                  this.getBalanceFT(provider, index);
                });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    manualDeposit: function(provider) {
      this.manualDepositItem = {
        ...provider,
        account_id: this.item.account_id,
        second_id: this.item.second_id
      };
      this.$nextTick(() => {
        this.$refs.manualdeposit.$refs.manualDeposit.show();
      });
    },
    afterManualDeposit: function() {
      this.$helpers.showDialog(this.$t("ui.combine.manual_deposit"), this.$t("message.success"), "success");
      this.$emit("clicked");
      this.getProviderList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), status, "error");
    },
    getBalanceFT: function(item, index) {
      let url = config.balanceFTUrl;
      const timestamp = Date.now();
      const dataString = config.md5KeyProviderFT + this.item.second_id + timestamp;
      const signature = CryptoJS.MD5(dataString).toString();

      const json = {
        userId: this.item.second_id,
        provider: item.actual_code,
        aggregator: item.aggregator,
        sign: signature,
        ts: timestamp,
      };

      // Use arrow function to preserve 'this' context and capture index
      const providerIndex = index;
      const self = this;

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response && providerIndex !== -1 && self.providerList[providerIndex]) {
              let success = false;
              if (typeof response.data.Status == "string") {
                success = response.data.Status == "1";
              } else {
                success = response.data.Status == 1;
              }
              
              const provider = self.providerList[providerIndex];
              if (success == true) {
                self.$set(provider, 'balance', parseFloat(response.data.Balance));
                self.$set(provider, 'balanceError', false);
              } else {
                self.$set(provider, 'balance', null);
                self.$set(provider, 'balanceError', true);
              }
              self.$set(provider, 'loadingBalance', false);
            }
          } catch (error) {
            // Error in processing response
            if (providerIndex !== -1 && self.providerList[providerIndex]) {
              const provider = self.providerList[providerIndex];
              self.$set(provider, 'balance', null);
              self.$set(provider, 'balanceError', true);
              self.$set(provider, 'loadingBalance', false);
            }
          }
        },
        function() {
          // HTTP Error
          if (providerIndex !== -1 && self.providerList[providerIndex]) {
            const provider = self.providerList[providerIndex];
            self.$set(provider, 'balance', null);
            self.$set(provider, 'balanceError', true);
            self.$set(provider, 'loadingBalance', false);
          }
        }
      );
    },
    manualWithdrawal: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.withdrawal_confirm", { provider: item.actual_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmWithdrawal(item);
          }
        });
    },
    confirmBulkWithdrawal: function() {
      if (this.bulkEligibleProviders.length === 0) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("message.no_data_available"), "warning");
        return;
      }

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.withdrawal_confirm", { provider: this.$t("ui.bulk_withdrawal") }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.bulkWithdrawal();
          }
        });
    },
    bulkWithdrawal: function() {
      const eligibleProviders = this.bulkEligibleProviders;
      
      if (eligibleProviders.length === 0) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("message.no_data_available"), "warning");
        return;
      }

      // Initialize withdrawal result list with all eligible providers
      this.withdrawalResultList = eligibleProviders.map(provider => ({
        provider: provider.actual_name || provider.actual_code,
        provider_code: provider.actual_code,
        aggregator: provider.aggregator,
        balance: provider.balance,
        status: 'processing', // processing, success, failed
        error: null
      }));

      // Show the withdrawal result modal immediately
      this.$nextTick(() => {
        this.$emit("clicked");
        this.$refs.withdrawalResult.show();
      });

      // Process each withdrawal asynchronously
      eligibleProviders.forEach((provider, index) => {
        this.processAsyncWithdrawal(provider, index);
      });
    },
    processAsyncWithdrawal: function(provider, index) {
      let url = config.withdrawFTUrl;
      let md5Key = config.md5KeyProviderFT;

      const timestamp = Date.now();
      const dataString = md5Key + this.item.second_id + timestamp;
      const signature = CryptoJS.MD5(dataString).toString();

      var json = {
        userId: this.item.second_id,
        sign: signature,
        ts: timestamp,
        auditBy: this.$store.getters.loginId
      };

      json.provider = provider.actual_code;
      json.aggregator = provider.aggregator;
      json.amount = Math.abs(parseFloat(provider.balance) || 0);

      const self = this;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              let success = false;
              if (typeof response.data.Status == "string") {
                success = response.data.Status == "1";
              } else {
                success = response.data.Status == 1;
              }
              
              if (success) {
                self.$set(self.withdrawalResultList[index], 'status', 'success');
                self.$set(self.withdrawalResultList[index], 'error', null);
              } else {
                self.$set(self.withdrawalResultList[index], 'status', 'failed');
                self.$set(self.withdrawalResultList[index], 'error', response.data.Description || self.$t("error.withdrawal_failed"));
              }
            } else {
              self.$set(self.withdrawalResultList[index], 'status', 'failed');
              self.$set(self.withdrawalResultList[index], 'error', errorTags.request.failed);
            }
          } catch (error) {
            self.$set(self.withdrawalResultList[index], 'status', 'failed');
            self.$set(self.withdrawalResultList[index], 'error', errorTags.request.failed);
          }
          
          // Refresh provider list after all withdrawals complete
          self.checkAndRefreshProviderList();
        },
        function(response) {
          // Error
          self.$set(self.withdrawalResultList[index], 'status', 'failed');
          self.$set(self.withdrawalResultList[index], 'error', errorTags.request.failed);
          
          // Refresh provider list after all withdrawals complete
          self.checkAndRefreshProviderList();
        }
      );
    },
    checkAndRefreshProviderList: function() {
      // Check if all withdrawals are complete (not processing)
      const allComplete = this.withdrawalResultList.every(item => item.status !== 'processing');
      
      if (allComplete) {
        // Refresh the provider list to get updated balances
        this.getProviderList();
      }
    },
    confirmWithdrawal: function(item) {
      let url = config.withdrawFTUrl;
      let md5Key = config.md5KeyProviderFT;

      const timestamp = Date.now();
      const dataString = md5Key + this.item.second_id + timestamp;
      const signature = CryptoJS.MD5(dataString).toString();

      var json = {
        userId: this.item.second_id,
        sign: signature,
        ts: timestamp,
        auditBy: this.$store.getters.loginId
      };

      json.provider = item.actual_code;
      json.aggregator = item.aggregator;
      json.amount = Math.abs(parseFloat(item.balance) || 0);

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.Status == "string") {
                this.feedback.success = response.data.Status == "1";
              } else {
                this.feedback.success = response.data.Status == 1;
              }
              this.feedback.status = response.data.Description;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t(this.feedback.status), "error");
              }
              this.getProviderList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    traceOutstanding: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.trace_outstanding"),
          text: this.$t("message.trace_outstanding_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmTraceOutstanding();
          }
        });
    },
    confirmTraceOutstanding: function() {
      let url = config.traceOutstandingTransferUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id
      };

      // this.outstandingTransferList = [];

      this.tracingOutstanding = true;
      this.$http.post(url, json).then(
        function(response) {
          this.tracingOutstanding = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                const outstandingList = Array.isArray(response.data.dt) ? response.data.dt : [];
                const outstandingByProvider = outstandingList.reduce((result, item) => {
                  result[item.provider_code] = item.outstanding;
                  return result;
                }, {});

                this.providerList.forEach(provider => {
                  const outstanding = Object.prototype.hasOwnProperty.call(outstandingByProvider, provider.actual_code)
                    ? parseFloat(outstandingByProvider[provider.actual_code])
                    : null;

                  this.$set(provider, "outstanding", Number.isNaN(outstanding) ? null : outstanding);
                });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.tracingOutstanding = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          // this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    canClearOutstanding: function(item) {
      const balance = Number(item.balance);
      const outstanding = Number(item.outstanding);

      return !item.balanceError
        && item.balance !== null
        && item.balance !== undefined
        && Number.isFinite(balance)
        && balance === 0
        && item.outstanding !== null
        && item.outstanding !== undefined
        && Number.isFinite(outstanding)
        && outstanding !== 0;
      // return true
    },
    clearOutstanding: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.clear_outstanding"),
          text: this.$t("message.clear_outstanding_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true,
          input: "text",
          inputPlaceholder: this.$t("ui.remark"),
          inputAttributes: {
            maxlength: 50
          },
          inputValidator: value => {
            if (!value || !value.trim()) {
              return this.$t("error.remarkRequired");
            }
          }
        })
        .then(result => {
          if (result.value) {
            this.confirmClearOutstanding(item, result.value.trim());
          }
        });
    },
    confirmClearOutstanding: function(item, remark) {
      let url = config.clearOutstandingTransferUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.account_id,
        second_id: this.item.second_id,
        remark: remark,
        provider_code: item.actual_code,
        aggregator: item.aggregator
      };

      this.feedback.success = true;
      this.$set(item, "clearingOutstanding", true);
      this.$http.post(url, json).then(
        function(response) {
          this.$set(item, "clearingOutstanding", false);
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
                this.$refs.fundTransferProvider.hide();
              } else {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t(this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.$set(item, "clearingOutstanding", false);
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.tracingOutstanding = false;
      this.transferBalance = 0;
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.providerList = [];
      this.transferBalance = 0;
      this.getProviderList();
      this.getMemberWallet();
    },
    closeResultModal: function() {
      this.$refs.withdrawalResult.hide();
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
